import { NgModule } from '@angular/core';
import { PassAmcInformationStoreModule } from '@common/store/pass-amc-information';
import { EffectsModule } from '@ngrx/effects';
import { PassAmcInformationStoreService } from './pass-amc-information.service';

@NgModule({
  providers: [PassAmcInformationStoreService],
  imports: [PassAmcInformationStoreModule, EffectsModule.forRoot()],
})
export class PassAmcInformationStoreServiceModule {}
